import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { getShop, ValidateCVRAndPNumber, CreateSaveShop, getPremiumShops, getPaintShops, updateShop, getShopUsers } from '../../../actions/shops'
import { loginAs } from '../../../actions/auth'
import { getCustomers } from '../../../actions/customers'
import { getSubscriptions } from '../../../actions/common'

// Components
import Phone from './../../../shared/components/Phone'
import Confirm from '../../../shared/components/Confirm'
// import HelpText from '../../../shared/components/HelpText'

// Elements
import Col from './../../../shared/elements/col'
import Row from './../../../shared/elements/row'
import Panel from './../../../shared/elements/panel'
import Text from './../../../shared/elements/text'
import DropDown from './../../../shared/elements/dropDown'
import Button from './../../../shared/elements/button'
import Switch from './../../../shared/elements/switch'
import LabelWrapper from './../../../shared/elements/labelWrapper'
import Label from './../../../shared/elements/label'
import Inline from './../../../shared/elements/inline'
import Radio from './../../../shared/elements/radio'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'
import Grid from '../../../shared/elements/grid'

// Styles
import './view.scss'

// Utils
import { translation } from '../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      previousSelectedShopId: 0,
      premiumShoplist: [],
      paintShoplist: [],
      allSubscriptions: [],
      companyCustomers: [],
      shop: {
        Active: true,
        Address: '',
        Alias: '',
        CountryId: 0,
        CVR: '',
        VendorId: '',
        VendorCode: '',
        ChainId: this.props.auth.user.ChainId,
        City: '',
        CompanyName: '',
        Email: '',
        Partners: [],
        // PermissionModules: [],
        PhoneCode: this.props.phonecode,
        SubscriptionId: null,
        PhoneNumber: '',
        ShopId: 0,
        ShopType: 0,
        TakseringType: 0,
        UserId: 0,
        UserName: '',
        ZipCode: '',
        Region: '',
        SubscriptionType: 0,
        PNumber: '',
        ChainUseStandardProductNumbers: true,
        IsTestAccount: false,
        IncludeInStatistics: true,
        MemberType: 0,
        ProductionType: 0,
        DbsActive: false,
        DBSWorkshopNumber: null,
        ShopCustomerId: null,
        DracarCompanyID: null
      },
      statistics: {
        active: true
      },
      ShopOwners: [],
      Employees: [],
      SupportUsers: [],
      Confirm: {
        Show: false,
        IsPermission: false,
        target: {
          value: '',
          name: '',
          checked: false
        }
      },
      selectedPartner: 0,
      paintPartner: 0,
      paintPartnerCustomer: 0
    }
    this.onInputChange = this.onInputChange.bind(this)
    // this.onModuleCheck = this.onModuleCheck.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onPhoneBlur = this.onPhoneBlur.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.onMemberTypeChange = this.onMemberTypeChange.bind(this)
    this.saveAddShop = this.saveAddShop.bind(this)
    this.addShop = this.addShop.bind(this)
    this.confirm = this.confirm.bind(this)
    this.notConfirm = this.notConfirm.bind(this)
    this.changePaintPartner = this.changePaintPartner.bind(this)
    this.getPaintPartnerCustomers = this.getPaintPartnerCustomers.bind(this)
    this.getSubscriptions = this.getSubscriptions.bind(this)
    this.getShopCustomersIfChainUseDBS = this.getShopCustomersIfChainUseDBS.bind(this)
    // this.adminPartners = this.adminPartners.bind(this)
  }

  componentDidMount () {
    this.getShopCustomersIfChainUseDBS(this.props)
    this.getShopInfoes(this.props)
    this.getPremiumShops(this.props)
    this.getPaintShops(this.props)
    this.getSubscriptions()
  }

  componentWillReceiveProps (nextProps) {
    this.getShopCustomersIfChainUseDBS(nextProps)
    this.getShopInfoes(nextProps)
    this.getPremiumShops(nextProps)
    this.getPaintShops(nextProps)
    this.getPaintPartnerCustomers(nextProps)
  }

  getSubscriptions () {
    this.props.getSubscriptions().then((res) => {
      this.setState({
        allSubscriptions: res.data
      })
    })
  }

  getShopInfoes (props) {
    if (typeof props.item.ShopId !== 'undefined') {
      props.getShop(props.item.ShopId).then((res) => {
        let shop = res.data
        let paintPartner = 0

        for (let i = 0; shop.Partners.length > i; i++) {
          if (shop.Partners[i].PartnerType === 1) {
            paintPartner = shop.Partners[i]
            i = shop.length
          }
        }
        this.setState({
          type: 'edit',
          shop: shop,
          paintPartner: paintPartner !== 0 ? paintPartner.ShopId : 0,
          paintPartnerCustomer: paintPartner.CustomerId !== undefined ? paintPartner.CustomerId : 0
        }, () => {
          this.getPaintPartnerCustomers(paintPartner.ShopId)
        }
      )
      })
      props.getShopUsers(props.item.ShopId).then((res) => {
        this.setState({
          ShopOwners: res.data.ShopOwners,
          Employees: res.data.Employees,
          SupportUsers: res.data.SupportUsers
        })
      })
    } else {
      this.resetCreate()
    }
  }

  getPremiumShops (props) {
    if (typeof props.auth.user.ChainId !== 'undefined') {
      props.getPremiumShops(props.auth.user.ChainId, props.item.ShopType).then((res) => {
        this.setState({
          premiumShoplist: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  getPaintShops (props) {
    if (typeof props.auth.user.ChainId !== 'undefined') {
      props.getPaintShops(props.auth.user.ChainId).then((res) => {
        this.setState({
          paintShoplist: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    let chainCountryId = this.props.countries.filter(c => c.CountryName === parseInt(this.props.auth.user.ChainCountry))[0].Id
    this.setState({
      type: 'create',
      shop: {
        Active: true,
        Address: '',
        Alias: '',
        CountryId: chainCountryId, // this.props.auth.user.ChainCountry,
        CVR: '',
        VendorId: '',
        VendorCode: '',
        ChainId: this.props.auth.user.ChainId,
        City: '',
        CompanyName: '',
        Email: '',
        Partners: [],
        // PermissionModules: [],
        PhoneCode: this.props.phonecode,
        PhoneNumber: '',
        ShopId: 0,
        ShopType: 0,
        TakseringType: 0,
        UserId: 0,
        UserName: '',
        ZipCode: '',
        Region: '',
        SubscriptionType: 0,
        SubscriptionId: null,
        PNumber: '',
        ChainUseStandardProductNumbers: true,
        IsTestAccount: false,
        IncludeInStatistics: true,
        MemberType: 0,
        DbsActive: false,
        DBSWorkshopNumber: null,
        ShopCustomerId: null
      },
      paintPartner: 0,
      paintPartnerCustomer: 0,
      Employees: [],
      ShopOwners: [],
      companyCustomers: [],
      SupportUsers: []
    })
  }

  loginAs (id, shopId, support, impersonate) {
    this.props.loginAs(id, shopId, support, impersonate).then((res) => {
      var startScreen = res.data.StartScreen
      if (startScreen === undefined || startScreen === null) startScreen = '/workscreen'
      this.props.router.push(startScreen)
    })
  }

  saveAddShop (e) {
    let shop = this.state.shop
     // update
    if (shop.ShopId > 0) {
      this.props.CreateSaveShop(shop).then((res) => {
        this.props.onSave(res.data, 'list')
        this.setState({
          shop: res.data
        })
      }, (err) => {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
          let errors = err.response.data.Errors
          let errorText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errorText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errorText), translation('216'))
        } else {
          // Toastr
          window.toastr.error(translation('2019'), translation('216'))
        }
      })
    }
    if (shop.ShopId === undefined || shop.ShopId === 0) {
      this.validateCvrAndPNumberNewShop()
    }
  }

  validateCvrAndPNumberNewShop () {
    let cvrAndPNumberDetails = {
      cvr: this.state.shop.CVR,
      countryId: this.state.shop.CountryId,
      pnumber: this.state.shop.PNumber
    }
    this.props.ValidateCVRAndPNumber(cvrAndPNumberDetails).then((err) => {
      if (err.data !== undefined && err.data.Error !== null) {
        let error = err.data.Error
        let errorText = ''
        if (error.DictionaryKey !== 0) {
          errorText += '<br />' + translation(error.DictionaryKey)
        }
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      }
    })
  }

  addShop () {
    let shop = this.state.shop
     // add
    this.props.CreateSaveShop(shop).then((res) => {
      this.props.onSave(res.data, 'create')
      this.setState({
        type: 'edit',
        shop: res.data
      })
    }, (err) => {
      if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
        let errors = err.response.data.Errors
        let errorText = ''
        errors.map((item) => {
          if (item.DictionaryKey !== 0) {
            errorText += '<br />' + translation(item.DictionaryKey)
          }
        })
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation('2019'), translation('216'))
      }
    })
  }

  onInputChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (e === undefined) {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    if (name === 'ProductionType') {
      value = parseInt(value)
    }
    if (name === 'selectedPartner') {
      this.setState({
        [name]: value
      })
    } else if (name === 'paintPartner') {
      let value = e.target.value
      this.changePaintPartner(value)
    } else if (name === 'paintPartnerCustomer') {
      let value = e.target.value
      this.editPaintPartner(value)
    } else {
      this.setState({
        shop: {
          ...this.state.shop,
          [name]: value
        }
      }, () => {
        if (['ShopType', 'DracarAllowed', 'UseForsiTokenApi', 'BookingPortalAllowed', 'CarOwnerPortalAllowed', 'ProductionType', 'DbsActive', 'ShopCustomerId', 'IncludeInStatistics'].includes(name)) {
          this.saveAddShop()
        }
      })
    }
  }
  // getCountryIdByName(countryName){
  //   for(let value in this.state.countries){
  //     if(value.CountryName === countryName){
  //       return value.Id
  //     }
  //   }
  // }

  changePaintPartner (value) {
    let partners = [...this.state.shop.Partners]

    let alreadyAdded = false
    for (let i = 0; i < partners.length; i++) {
      if (partners[i].PartnerType === 1) {
        // edit partners
        partners[i].ShopId = value
        alreadyAdded = true
      }
    }
    if (!alreadyAdded) {
      // add new partners
      partners.push({
        ShopId: value,
        PartnerType: 1
      })
    }
    this.setState({
      shop: {
        ...this.state.shop,
        Partners: partners
      },
      paintPartner: value,
      paintPartnerCustomer: 0
    }, this.saveAddShop, this.getPaintPartnerCustomers(value))
  }

  editPaintPartner (value) {
    let partners = [...this.state.shop.Partners]

    for (let i = 0; i < partners.length; i++) {
      if (parseInt(partners[i].ShopId) === parseInt(this.state.paintPartner) && partners[i].PartnerType === 1) {
        partners[i].CustomerId = parseInt(value)
      }
    }

    this.setState({
      shop: {
        ...this.state.shop,
        Partners: partners
      },
      paintPartnerCustomer: value
    }, this.saveAddShop)
  }

  getPaintPartnerCustomers (shop) {
    if (typeof shop === 'object' && shop.item !== undefined && shop.item.ShopId !== undefined) {
      shop = shop.item.ShopId
    }
    this.props.getCustomers(shop).then((res) => {
      this.setState({
        PaintPartnerCustomers: res.data
      })
    })
  }

  getShopCustomersIfChainUseDBS (props, from) {
    var shopId = props.item.ShopId
    var usesDBS = props.auth.permissions.ChainAssessmentSystem === 2
    var isSameShopAsState = shopId === this.state.ShopId
    if (typeof shopId === 'undefined' || shopId === 0 || !usesDBS || isSameShopAsState) return null

    this.props.getCustomers(shopId).then((res) => {
      this.setState({
        companyCustomers: res.data
      })
    })
  }

  // onModuleCheck (e, dontCheck) {
  //   if (!dontCheck) {
  //     this.setState({
  //       Confirm: {
  //         Show: true,
  //         IsPermission: true,
  //         target: {
  //           value: e.target.value,
  //           name: e.target.name,
  //           checked: e.target.checked
  //         }
  //       }
  //     })
  //     return
  //   }

  //   let modules = [...this.state.shop.PermissionModules]
  //   var value = e.target.value
  //   if (e.target.checked === false) {
  //     modules = modules.filter(function (el) {
  //       return Number(el.PermissionModuleId) !== Number(value)
  //     })
  //   } else {
  //     modules.push({
  //       PermissionModuleId: value
  //     })
  //   }
  //   this.setState({
  //     shop: {
  //       ...this.state.shop,
  //       PermissionModules: modules
  //     }
  //   }, this.saveAddShop)
  // }

  onPhoneChange (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'PhoneNumber'
      this.setState({
        shop: {
          ...this.state.shop,
          [name]: value
        }
      })
    } else {
      this.setState({
        shop: {
          ...this.state.shop,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, this.saveAddShop)
    }
  }

  onPhoneBlur (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'PhoneNumber'
      this.setState({
        shop: {
          ...this.state.shop,
          [name]: value
        }
      }, this.saveAddShop)
    }
  }

  onRadioChange (e, dontCheck) {
    // if (typeof e.preventDefault === 'function') e.preventDefault()
    let value = e.target.value
    let name = e.target.name

    if (e.target.name === 'ChainUseStandardProductNumbers' || e.target.name === 'Active') {
      value = e.target.value === 'true' || e.target.value === true
      if (e.target.type === 'checkbox') value = e.target.checked
    }
    if (this.state.shop[name] + '' === '' + value) return
    if (dontCheck !== true) {
      this.setState({
        Confirm: {
          Show: true,
          IsPermission: false,
          target: {
            value: value,
            name: name,
            checked: e.target.checked
          }
        }
      })
      return
    }
    this.setState({
      shop: {
        ...this.state.shop,
        [name]: value
      }
    }, this.saveAddShop)
  }

  onMemberTypeChange (e, dontCheck) {
    let value = e.target.value
    let name = e.target.name
    let checked = e.target.checked
    // Open up confirmation
    if (dontCheck !== true) {
      this.setState({
        Confirm: {
          Show: true,
          IsPermission: false,
          target: {
            value: value,
            name: name,
            checked: checked
          }
        }
      })
      return
    }
    if (name === 'MemberType') {
      // These checkboxes work the same way as the radio buttons, but with an option to have none of them checked
      if (e.target.value === this.state.shop.MemberType.toString()) value = 0
    }
    this.setState({
      shop: {
        ...this.state.shop,
        [name]: value
      }
    }, this.saveAddShop)
  }

  renderShop () {
    if (this.state.previousSelectedShopId !== this.state.shop.ShopId) {
      this.setState({
        previousSelectedShopId: this.state.shop.ShopId
      })
    }

    let shop = this.state.shop
    return (
      <Panel title={translation('700')}>
        <DropDown name='CountryId' value={shop.CountryId} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('1701')}>
          {this.props.countries.map((val, index) => {
            let showVal = translation(val['CountryName'])
            return <option value={val['Id']} key={index}>{showVal}</option>
          })}
        </DropDown>
        <Text name='CVR' value={shop.CVR || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('41')} />
        <Text name='PNumber' value={shop.PNumber || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('15222')} />
        <Text name='CompanyName' value={shop.CompanyName || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('30')} />
        <Text name='Alias' value={shop.Alias || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('1863')} />
        <Text name='Address' value={shop.Address || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('25')} />
        <Text name='ZipCode' value={shop.ZipCode || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('40')} />
        <Text name='Region' value={shop.Region || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('14753')} />
        <Text name='City' value={shop.City || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('37')} />
        <Text name='VendorId' value={shop.VendorId || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('14754')} />
        <Text name='VendorCode' value={shop.VendorCode || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('15250')} />
        <LabelWrapper labelText={translation('38')}>
          <Phone onChange={this.onPhoneChange} onBlur={this.onPhoneBlur} code={shop.PhoneCode || ''} number={shop.PhoneNumber || ''} />
        </LabelWrapper>
        <Text name='Email' value={shop.Email || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('1052')} />
        <Text name='UserName' value={shop.UserName || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('1')} />
        <Switch name='Active' checked={shop.Active} onChange={this.onRadioChange} labelText={translation('295')} />
        <div>
          {loginAs}
        </div>
      </Panel>
    )
  }

  renderSettings () {
    let shop = this.state.shop
    let chainUsesDBS = this.props.auth.permissions.ChainAssessmentSystem === 2

    const prodNrChecked = (type, standard) => {
      if (standard === type) {
        return (
          true
        )
      }
    }
    return (
      <Panel title={translation('6')}>
        <DropDown name='ShopType' onChange={this.onInputChange} value={shop.ShopType !== null ? shop.ShopType : 0} labelText={translation('1167')} onBlur={this.saveAddShop} disabled={shop.ShopId > 0}>
          <option value={0}>{translation('660')}</option>
          <option value={1}>{translation('635')}</option>
          <option value={2}>{translation('736')}</option>
        </DropDown>
        <Switch id='TestAccount' name='IsTestAccount' labelText={16381} checked={shop.IsTestAccount} onChange={this.onInputChange} />
        {shop.ShopType >= 1 ? <Switch id='AllowBookingPortal' name='BookingPortalAllowed' labelText={16852} checked={shop.BookingPortalAllowed} onChange={this.onInputChange} /> : null}
        {shop.ShopType >= 1 ? <Switch id='AllowCarOwnerPortal' name='CarOwnerPortalAllowed' labelText={18151} checked={shop.CarOwnerPortalAllowed} onChange={this.onInputChange} /> : null}
        {shop.ShopType >= 1 && !chainUsesDBS ? <Switch id='UseForsiToken' name='UseForsiTokenApi' onChange={this.onInputChange} checked={shop.UseForsiTokenApi} labelText={translation('16420')} /> : null}
        {shop.ShopType >= 1 ? <Switch id='Dracar' name='DracarAllowed' onChange={this.onInputChange} checked={shop.DracarAllowed} labelText={translation('18364')} /> : null}
        {shop.DracarAllowed ? <Text name='DracarCompanyId' value={shop.DracarCompanyId || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('18456')} /> : null}
        {((shop.SubscriptionId !== null && shop.SubscriptionId > 0) || this.state.type !== 'edit') && (
        <LabelWrapper labelText={translation('15295')} helpText={translation('15312') + ' ' + translation('15313')}>
          <Radio id='StandardProductNumbers_yes' name='ChainUseStandardProductNumbers' value='true' onChange={(e) => this.onRadioChange(e, true)} checked={prodNrChecked(true, shop.ChainUseStandardProductNumbers) || false} labelText={translation('15309')} />
          <Radio id='StandardProductNumbers_no' name='ChainUseStandardProductNumbers' value='false' onChange={(e) => this.onRadioChange(e, true)} checked={prodNrChecked(false, shop.ChainUseStandardProductNumbers) || false} labelText={translation('15310')} />
        </LabelWrapper>)}
      </Panel>
    )
  }

  renderProductionTypes () {
    let shop = this.state.shop

    return (
      <Panel title={translation('1167')}>
        <Radio id='ProductionType_PersonCars' name='ProductionType' value='0' onChange={this.onInputChange} checked={shop.ProductionType === 0} labelText={translation('1168')} />
        <Radio id='ProductionType_BigCars' name='ProductionType' value='1' onChange={this.onInputChange} checked={shop.ProductionType === 1} labelText={translation('1169')} />
        <Radio id='ProductionType_Industry' name='ProductionType' value='2' onChange={this.onInputChange} checked={shop.ProductionType === 2} labelText={translation('1170')} />
      </Panel>
    )
  }

  isPartnerInList (partners, shop) {
    if (partners !== undefined && shop !== undefined) {
      for (let i = 0; i < partners.length; i++) {
        if (partners[i].ShopId === shop.ShopId && [0, 2].includes(partners[i].PartnerType)) {
          return true
        }
      }
    }
    return false
  }

  renderPartners () {
    if (this.state.shop.SubscriptionId < 4) return null
    let shop = this.state.shop
    // Filters out added partners and itself
    const filteredPremiumShoplist = this.state.premiumShoplist.filter(shop => this.isPartnerInList(this.state.shop.Partners, shop) === false && shop.ShopId !== this.state.shop.ShopId && shop.ShopType === this.state.shop.ShopType)

    const adminPartners = (e) => {
      let partners = [...this.state.shop.Partners]
      var value = 0

      if (e.target.value === undefined) {
        console.log('delete???', e.target)
        value = e.target.id
        partners = partners.filter(function (el) {
          return Number(el.ShopId) !== Number(value)
        })
      } else {
        value = e.target.value
        partners.push({
          ShopId: value
        })
      }
      this.setState({
        shop: {
          ...this.state.shop,
          Partners: partners
        }
      }, this.saveAddShop)
    }
    const addPartner = () => {
      let partners = this.state.shop.Partners
      var value = this.state.selectedPartner

      if (value !== 0 && value !== undefined) {
        let newPartner = {
          ShopId: value,
          PartnerType: filteredPremiumShoplist.find(x => x.ShopId === value).ShopType === 0 ? 0 : 2
        }
        this.setState({
          shop: {
            ...this.state.shop,
            Partners: [...partners, newPartner]
          },
          selectedPartner: 0
        }, this.saveAddShop)
      }
    }
    const renderShops = (val, key) => {
      if ([0, 2].includes(val.PartnerType)) {
        return (
          <Inline fillChildNum={[0]} block key={key}>
            <Label>{val.ShopName}</Label>
            <RemoveButton onClick={() => adminPartners({ target: { id: val.ShopId } })} id={val.ShopId} size='s' />
          </Inline>
        )
      }
    }
    const renderShopList = (val, key) => {
      return (
        <option key={key} value={val.ShopId}>{val.ShopName}</option>
      )
    }
    return (
      <Panel title={translation('649')}>
        {shop.Partners !== null && shop.Partners.map(renderShops)}
        <Grid cols={['200px', 'auto']}>
          <DropDown ref='partnerShops' name='selectedPartner' onChange={this.onInputChange} value={this.state.selectedPartner}>
            <option value={0}>{translation('890')} {translation('700')}</option>
            {filteredPremiumShoplist.map(renderShopList)}
          </DropDown>
          <AddButton onClick={addPartner} />
        </Grid>
      </Panel>
    )
  }

  renderPaintPartner () {
    const filteredPaintShoplist = this.state.paintShoplist.filter(shop => shop.ShopId !== this.state.shop.ShopId)
    const renderShopList = (val, key) => {
      return (
        <option key={key} value={val.ShopId}>{val.ShopName}</option>
      )
    }
    const renderPaintPartnerCustomers = () => {
      return this.state.PaintPartnerCustomers.filter(x => x.RelationType === 0).reduce((mapped, elem, key) => {
        if (elem.Active) {
          let element = <option key={key} value={elem.CustomerId}>{elem.Name}</option>
          return [...mapped, element]
        }
        return mapped
      }, [])
    }

    return (
      <Panel title={translation('161')}>
        <DropDown name='paintPartner' value={this.state.paintPartner} onChange={this.onInputChange} labelText={translation('867')}>
          <option value={0}>{translation('890')} {translation('700')}</option>
          {filteredPaintShoplist.map(renderShopList)}
        </DropDown>
        {this.state.PaintPartnerCustomers !== undefined && (
          <DropDown name='paintPartnerCustomer' value={this.state.paintPartnerCustomer} onChange={this.onInputChange} labelText={translation('14805')}>
            <option value={0}>{translation('890')} {translation('58')}</option>
            {renderPaintPartnerCustomers()}
          </DropDown>
        )}
      </Panel>
    )
  }

  renderSubscriptions () {
    let shop = this.state.shop

    const renderSubscription = (item, key) => {
      var inputId = 'shop_subscription_' + item.Name
      var checked = (shop.SubscriptionId + '') === (item.SubscriptionId + '')
      var name = item.Name
      if (item.SubscriptionId <= 0) name = translation('433')
      return (
        <Radio key={key} id={inputId} name='SubscriptionId' value={item.SubscriptionId} checked={checked} labelText={name} onChange={this.onRadioChange} />
      )
      // return (
      //   <div key={key} className='radio__custom__wrapper'>
      //     <div className='radio__custom'>
      //       <input type='radio' id={inputId} name='SubscriptionId' value={item.SubscriptionId} checked={checked} onClick={this.onRadioChange} onChange={() => { return }} />
      //       <label htmlFor={inputId}>{name}</label>
      //     </div>
      //   </div>
      // )
    }

    return (
      <Panel title={translation('2149')}>
        <LabelWrapper labelText={translation('2151')}>
          {this.state.allSubscriptions.map(renderSubscription)}
        </LabelWrapper>
      </Panel>
    )
  }

  renderStatistics () {
    // // The labelText represents the name before checkbox and memberType is the type of member which checkbox represents
    // const renderCheckbox = (labelText, memberType) => {
    //   let checked = this.state.shop.MemberType === memberType
    //   var inputId = 'shop_memberType_' + labelText
    //   return (
    //     <div className='control__group checkbox__custom__outer'>
    //       <label>{labelText}</label>
    //       <div className='checkbox__custom__wrapper'>
    //         <div className='checkbox__custom'>
    //           <input type='checkbox' id={inputId} name='MemberType' value={memberType} checked={checked} onChange={this.onMemberTypeChange} />
    //           <label htmlFor={inputId} />
    //         </div>
    //       </div>
    //     </div>
    //   )
    // }

    // const ActiveChecked = (type, active) => {
    //   if (active === type) {
    //     return (
    //       true
    //     )
    //   }
    // }

    return (
      <Panel title={389} helpText={15328}>
        <Switch name='IncludeInStatistics' labelText={15323} checked={this.state.shop.IncludeInStatistics} onChange={this.onInputChange} />
        {this.state.shop.IncludeInStatistics && (
          <LabelWrapper labelText={15324} >
            <Radio labelText={15332} name='MemberType' value={0} checked={this.state.shop.MemberType === 0} onChange={this.onMemberTypeChange} />
            <Radio labelText={15325} name='MemberType' value={1} checked={this.state.shop.MemberType === 1} onChange={this.onMemberTypeChange} />
            <Radio labelText={15326} name='MemberType' value={2} checked={this.state.shop.MemberType === 2} onChange={this.onMemberTypeChange} />
            <Radio labelText={15327} name='MemberType' value={3} checked={this.state.shop.MemberType === 3} onChange={this.onMemberTypeChange} />
          </LabelWrapper>
        )}
      </Panel>
    )

    // return (
    //   <div className='white__box'>
    //     <div className='title'>{translation('389')}<HelpText className='helpText' text={translation('15328')} left /></div>
    //     <div className='form fifty'>
    //       <div className='control__group radio__custom__outer'>
    //         <label>{translation('15323')}</label>
    //         <div className='radio__custom__wrapper'>
    //           <div className='radio__custom'>
    //             <input type='radio' id='statistics_active_yes' name='IncludeInStatistics' value='true' checked={ActiveChecked(true, this.state.shop.IncludeInStatistics) || false} onChange={this.onRadioChange} />
    //             <label htmlFor='statistics_active_yes'>{translation('47')}</label>
    //           </div>
    //           <div className='radio__custom'>
    //             <input type='radio' id='statistics_active_no' name='IncludeInStatistics' value='false' checked={ActiveChecked(false, this.state.shop.IncludeInStatistics) || false} onChange={this.onRadioChange} />
    //             <label htmlFor='statistics_active_no'>{translation('48')}</label>
    //           </div>
    //         </div>
    //       </div>
    //       {this.state.shop.IncludeInStatistics && (
    //         <div className='checkbox_group_wrapper'>
    //           <label className='boldLabel'>{translation('15324')}</label>
    //           {renderCheckbox(translation('15325'), 1)}
    //           {renderCheckbox(translation('15326'), 2)}
    //           {renderCheckbox(translation('15327'), 3)}
    //         </div>
    //       )}

    //     </div>
    //   </div>
    // )
  }

  renderUsers (Titele, Users, request) {
    const User = (val, key) => {
      if (!(val.Id > 0)) {
        return
      }
      let textKey = support ? '18033' : '57'
      let support = request === 'Support'
      let impersonate = request === 'Impersonate'
      let shopId = support ? this.state.shop.ShopId : 0

      if (support && !val.CanLogin || impersonate && !val.CanImpersonate) {
        return <LabelWrapper labelText={val.Name} key={key} />
      }

      return (
        <LabelWrapper labelText={val.Name} key={key}>
          <Button style='link' onClick={this.loginAs.bind(this, val.Id, shopId, support, impersonate)} labelText={translation(textKey)} />
        </LabelWrapper>
      )
    }

    return (
      <Panel title={Titele}>
        {Users.map(User)}
      </Panel>
    )
  }

  renderDBS () {
    return (
      <Panel title={translation('17930')}>
        <Switch id='DbsActive' name='DbsActive' labelText={295} checked={this.state.shop.DbsActive} onChange={this.onInputChange} />
        <Text name='DBSWorkshopNumber' value={this.state.shop.DBSWorkshopNumber || ''} onChange={this.onInputChange} onBlur={this.saveAddShop} labelText={translation('17931')} />
        <LabelWrapper labelText={translation('14905')} helpText={translation('14907')}>
          <DropDown onChange={this.onInputChange} name='ShopCustomerId' value={this.state.shop.ShopCustomerId}>
            <option key={null} value={null}>{translation('14906')}</option>
            {this.state.companyCustomers.filter(x => x.Active === true).map((val, key) => <option key={val.CustomerId} value={val.CustomerId}>{val.Name}</option>)}
          </DropDown>
        </LabelWrapper>
      </Panel>
    )
  }

  render () {
    return (
      <Row>
        <Col>
          {this.renderShop()}
        </Col>
        <Col>
          {this.renderSettings()}
          {this.renderProductionTypes()}
          {this.renderUsers(translation('10'), this.state.Employees, 'Impersonate')}
        </Col>
        <Col>
          {this.state.shop.ShopType !== 2 && this.state.shop.ShopId !== 0 && this.renderPartners()}
          {this.state.shop !== undefined && this.state.shop.ShopType === 1 && this.state.shop.ShopId !== 0 && this.renderPaintPartner()}
          {this.renderUsers(translation('1860'), this.state.ShopOwners, 'Impersonate')}
          {this.renderSubscriptions()}
        </Col>
        <Col>
          <div>
            {this.props.auth.user.ChainId === '2' && (this.props.auth.user.UserType === 2 || this.props.auth.user.UserType === 1) && (this.renderStatistics())}
          </div>
          {this.props.auth.permissions.ChainAssessmentSystem === 2 && this.renderDBS()}
          {this.renderUsers(translation('659'), this.state.SupportUsers, 'Support')}
        </Col>
        {this.state.Confirm.Show === true && <Confirm t={translation} renderText={() => translation('14748')} confirm={this.confirm} notConfirm={this.notConfirm} />}
      </Row>
    )
  }

  confirm () {
    this.setState({
      Confirm: {
        ...this.state.Confirm,
        Show: false
      }
    })

    if (this.state.Confirm.IsPermission) {
    } else {
      if (this.state.Confirm.target.name === 'MemberType') {
        this.onMemberTypeChange(this.state.Confirm, true)
      } else {
        this.onRadioChange(this.state.Confirm, true)
      }
    }
  }

  notConfirm () {
    this.setState({
      Confirm: {
        ...this.state.confirm,
        Show: false
      }
    })
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes,
    countries: state.common.countries
  }
}

export default connect(mapStateToProps, {
  getShop,
  CreateSaveShop,
  ValidateCVRAndPNumber,
  getPremiumShops,
  getPaintShops,
  updateShop,
  loginAs,
  getShopUsers,
  getCustomers,
  getSubscriptions
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Shops/View/index.js